<div [class.details-container]="selectedEvent !== undefined">
  <app-cts-gantry-startup-pane
    #startupPane
    [events]="events"
    [selectionModel]="selectionModel"
    [systemDetails]="systemDetails"
    (detailEventChange)="selectedEvent = $event"
  ></app-cts-gantry-startup-pane>

  @if (selectedEvent) {
    <app-cts-gantry-log-table
      class="slide-in"
      [ctsEvent]="selectedEvent"
      [logCacheModel]="logCacheModel"
      [systemDetails]="systemDetails"
      (cancelChange)="startupPane.openCompare()"
    ></app-cts-gantry-log-table>
  }
</div>
